module.exports = __webpack_public_path__ + "img/moh.a9bf1c95.jpg";